import axios from 'axios';
import { variables } from './variables.js';
import axiosInstance from './axiosInstance';

const API_URL = variables.INVOICE_API;
const API_URL_REMOVE_INVOICE = variables.PAID_INVOICE_API;

const getInvoices = async (params) => {
  const queryString = params ? `?${new URLSearchParams(params).toString()}` : '';
  const url = `${API_URL}${queryString}`;
  const response = await axiosInstance.get(url);
  return response.data;
};

const getInvoice = async (invoiceId) => {
  const response = await axiosInstance.get(`${API_URL}/${invoiceId}`);
  return response.data;
};

const addInvoice = async (invoice) => {
  const response = await axios.post(API_URL, invoice);
  return response.data;
};

const updateInvoice = async (invoiceId, invoice) => {
  const response = await axios.put(`${API_URL}/${invoiceId}`, invoice);
  return response.data;
};

const deleteInvoice = async (invoiceId) => {
  const response = await axios.delete(`${API_URL}/${invoiceId}`);
  return response.data;
};

export const removePaidInvoiceFromCart = async (customerId, userId) => {
  try {
    return await axiosInstance.post(`${API_URL_REMOVE_INVOICE}/RemovePaidInvoiceFromCart`,
      null,
      {
        params: {
          customerId,
          userId,
        },
      }
    );
  } catch (error) {
    return { error: error.response?.data || error.message };
  }
};


export default {
  getInvoices,
  getInvoice,
  addInvoice,
  updateInvoice,
  deleteInvoice,
  removePaidInvoiceFromCart
};